<template>
  <div class="cursor-wrapper">
    <div class="cursor-dot" :style="dotStyle"></div>
    <div class="cursor-ring" :style="ringStyle"></div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const x = ref(0)
const y = ref(0)

const ringX = ref(0)
const ringY = ref(0)

let raf = null

const handleMouseMove = (e) => {
  x.value = e.clientX
  y.value = e.clientY
}

const animate = () => {
  ringX.value += (x.value - ringX.value) * 0.12
  ringY.value += (y.value - ringY.value) * 0.12

  raf = requestAnimationFrame(animate)
}

const dotStyle = computed(() => ({
  transform: `translate3d(${x.value}px, ${y.value}px, 0)`
}))

const ringStyle = computed(() => ({
  transform: `translate3d(${ringX.value}px, ${ringY.value}px, 0)`
}))

onMounted(() => {
  window.addEventListener('mousemove', handleMouseMove)
  animate()
})

onUnmounted(() => {
  window.removeEventListener('mousemove', handleMouseMove)
  if (raf) cancelAnimationFrame(raf)
})
</script>

<style scoped>
.cursor-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 999999;
}

/* IMPORTANT: both must be fixed + centered */
.cursor-dot,
.cursor-ring {
  position: fixed;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

/* dot */
.cursor-dot {
  width: 6px;
  height: 6px;
  background: #393D60;
  border-radius: 50%;
}

/* ring */
.cursor-ring {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(57, 61, 96, 0.5);
  border-radius: 50%;
}

@media (hover: none) and (pointer: coarse) {
  .cursor-wrapper {
    display: none !important;
  }
}
</style>